module.exports = __webpack_public_path__ + "static/qxpress-caa3fe08f87710d3853314e98748a5bc.png";